var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondashboardnoGateway = function SvgIcondashboardnoGateway(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Dashboard/icon.dashboard.no_gateway") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dashboard/icon.dashboard.no_gateway",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gateway",
    transform: "translate(3.000000, 3.000000)",
    fill: "#C0C0C0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1212121,0 C50.6816855,0 56,5.66143155 56,12.6451613 L56,43.3548387 C56,50.3385684 50.6816855,56 44.1212121,56 L11.8787879,56 C5.31831449,56 0,50.3385684 0,43.3548387 L0,12.6451613 C0,5.66143155 5.31831449,0 11.8787879,0 L44.1212121,0 Z M44.1212121,1.80645161 L11.8787879,1.80645161 C6.3833264,1.80645161 1.90472671,6.44103851 1.70399256,12.2388212 L1.6969697,12.6451613 L1.6969697,43.3548387 C1.6969697,49.2048461 6.05067254,53.9723877 11.4970745,54.1860724 L11.8787879,54.1935484 L44.1212121,54.1935484 C49.6166736,54.1935484 54.0952733,49.5589615 54.2960074,43.7611788 L54.3030303,43.3548387 L54.3030303,12.6451613 C54.3030303,6.79515391 49.9493275,2.0276123 44.5029255,1.81392756 L44.1212121,1.80645161 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,18 C33.5228475,18 38,22.4771525 38,28 C38,33.5228475 33.5228475,38 28,38 C22.4771525,38 18,33.5228475 18,28 C18,22.4771525 22.4771525,18 28,18 Z M28,19.6666667 C23.3976271,19.6666667 19.6666667,23.3976271 19.6666667,28 C19.6666667,32.6023729 23.3976271,36.3333333 28,36.3333333 C32.6023729,36.3333333 36.3333333,32.6023729 36.3333333,28 C36.3333333,23.3976271 32.6023729,19.6666667 28,19.6666667 Z",
    id: "Oval"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.2317787,0.3598156 C55.5853428,-0.0644612969 56.2159075,-0.121785361 56.6401844,0.23177872 C57.0318246,0.558145564 57.110795,1.12053661 56.8425391,1.53883241 L56.7682213,1.6401844 L6.76822128,61.6401844 C6.4146572,62.0644613 5.7840925,62.1217854 5.3598156,61.7682213 C4.96817539,61.4418544 4.88920504,60.8794634 5.15746088,60.4611676 L5.23177872,60.3598156 L55.2317787,0.3598156 Z",
    id: "Line-12",
    fill: "#C0C0C0",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondashboardnoGateway);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.dashboard.no_gateway.59e8a3e10ea2a5455d1496e1c0cd861c.svg";